import React from 'react';

export const SunIcon = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="11.9998"
      cy="11.9998"
      r="5.75375"
      fill="white"
    />
    <g>
      <circle
        cx="3.08982"
        cy="6.85502"
        r="1.71143"
        transform="rotate(-60 3.08982 6.85502)"
        fill="white"
      />
      <circle
        cx="3.0903"
        cy="17.1436"
        r="1.71143"
        transform="rotate(-120 3.0903 17.1436)"
        fill="white"
      />
      <circle cx="12" cy="22.2881" r="1.71143" fill="white" />
      <circle
        cx="20.9101"
        cy="17.1436"
        r="1.71143"
        transform="rotate(-60 20.9101 17.1436)"
        fill="white"
      />
      <circle
        cx="20.9101"
        cy="6.8555"
        r="1.71143"
        transform="rotate(-120 20.9101 6.8555)"
        fill="white"
      />
      <circle cx="12" cy="1.71143" r="1.71143" fill="white" />
    </g>
  </svg>
);
